import React, { Component } from "react";
import PropTypes from "prop-types";
import { monthYear, monthFullYear } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import { get } from "lodash";
import {
  INCOMING_LINE_ITEMS,
  NO_QUOTE,
  FULL,
  PARTIAL
} from "MODULES/IncomingQuotes/constants";
import New from "MODULES/IncomingQuotes/Parts/New";
import { DataTable, PartNumber, NoteTooltip } from "MODULES/shared/components";
import LineItemStatusCell from "MODULES/shared/components/LineItemStatusCell";
import { NoteTooltipTableCell } from "MODULES/shared/components/NoteTooltip";
import ModifiedFlag from "MODULES/parts/components/ModifiedFlag";
import { ID, TOTAL } from "APP_ROOT/constants";
import { IncidentRelatedFlag } from "MODULES/IncomingQuotes/shared/IncidentRelatedFlag";
import { AsIsFlag } from "MODULES/IncomingQuotes/shared/AsIsFlag";
import { truncate } from "LIB/formatters/text";
import { translateProps } from "MODULES/shared/decorators";
import { decorators, Paginator } from "@orange-marmalade/paginate-this";
import Edit from "../../Parts/EditPart";
import Controls from "./Controls";

const paginatorList = "incomingQuotes/lineItems";

class LineItemsTable extends Component {
  static propTypes = {
    quote: PropTypes.shape({
      incoming_quote_line_items: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          quote_type: PropTypes.string.isRequired,
          dom: PropTypes.string,
          condition: PropTypes.string,
          cost: PropTypes.string
        })
      )
    }).isRequired
  };

  state = {
    editModalOpen: false
  };

  openModal = lineItem =>
    this.setState({ editModalOpen: true, selectedLineItem: lineItem });

  closeModal = () => this.setState({ editModalOpen: false });

  renderRow = (lineItem, i) => (
    <tr
      key={lineItem.id}
      className="clickable"
      onClick={() => this.openModal(lineItem)}
    >
      <td>
        {i + 1}
        <span style={{ position: "absolute", left: 0, marginTop: 0 }}>
          {lineItem.purchase_status === FULL && (
            <NoteTooltip
              icon={"fa-check-square"}
              placement={"top"}
              note={"Full Qty Purchase"}
              color={"#4CAF50"}
            />
          )}
          {lineItem.purchase_status === PARTIAL && (
            <NoteTooltip
              icon="fa-star-half-o"
              placement="top"
              note="Partial Purchase"
              color="#FF9800"
            />
          )}
        </span>
      </td>
      <LineItemStatusCell lineItem={lineItem}>
        <PartNumber part={lineItem.part} showClipBoard />
      </LineItemStatusCell>
      <td>{INCOMING_LINE_ITEMS.quoteType[lineItem.quote_type].abbrev}</td>
      <td>{get(lineItem, "rfq_as_alt.name")}</td>
      <td>{monthFullYear(lineItem.dom)}</td>
      <td>{lineItem.expected_serial_number}</td>
      <td>
        {lineItem.trace_type &&
          INCOMING_LINE_ITEMS.traceTypes[lineItem.trace_type].label}
      </td>
      <td>{truncate(lineItem.traced_to, 13)}</td>
      <td>{lineItem.tag_date && monthYear(lineItem.tag_date)}</td>
      <td>{truncate(lineItem.tagged_by, 13)}</td>
      <td>{lineItem.modified && <ModifiedFlag />}</td>
      <td>
        {lineItem.condition &&
          lineItem.quote_type !== NO_QUOTE &&
          INCOMING_LINE_ITEMS.condition[lineItem.condition].abbrev}
        <AsIsFlag lineItem={lineItem} />
        <IncidentRelatedFlag lineItem={lineItem} />
      </td>
      <td>{lineItem.quantity}</td>
      <td>{lineItem.lead_time}</td>
      <td className="text-right">{dollars(lineItem.exchange_fee)}</td>
      <td className="text-right">{dollars(lineItem.cost)}</td>
      <td className="text-right">{truncate(lineItem.warranty, 20)}</td>
      <NoteTooltipTableCell note={lineItem.notes} />
      <Controls lineItem={lineItem} />
    </tr>
  );

  render() {
    const { quote, results, isLoading } = this.props;
    const { editModalOpen, selectedLineItem } = this.state;
    return (
      <div>
        <h2 style={{ marginTop: 26 }}>
          Parts
          <New />
          <Edit
            id={quote.get(ID)}
            open={editModalOpen}
            close={this.closeModal}
            selectedLineItem={selectedLineItem}
          />
        </h2>
        <DataTable.Mini loading={isLoading} numbered noMargin>
          <DataTable.Head>
            <th />
            <th>Part #</th>
            <th>Type</th>
            <th>RFQ as Alt</th>
            <th>DOM</th>
            <th>Serial #</th>
            <th>Trace Type</th>
            <th>Trace To</th>
            <th>Tag Date</th>
            <th>Tagged By</th>
            <th />
            <th>Cond</th>
            <th>QTY</th>
            <th>LT</th>
            <th className="text-right">Exch Fee</th>
            <th className="text-right">Cost/Unit</th>
            <th className="text-right">Warranty</th>
            <th />
            <th className="text-right">&nbsp;</th>
          </DataTable.Head>
          <DataTable.Body>
            {results.map(this.renderRow)}
            <tr style={{ backgroundColor: "transparent" }}>
              <td />
              <td className="text-right" colSpan={15}>
                <h4 className="margin-top-none margin-bottom-none">
                  Total: {dollars(quote.get(TOTAL))}
                </h4>
              </td>
            </tr>
          </DataTable.Body>
        </DataTable.Mini>
        <nav
          className="text-center margin-top-none"
          aria-label="Search results pages"
        >
          <Paginator listId={paginatorList} />
        </nav>
      </div>
    );
  }
}

const withListId = translateProps(() => ({
  listId: paginatorList
}));

export default withListId(decorators.tabulate(LineItemsTable));



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Detail/LineItems/LineItemsTable.jsx